import { useAsyncFn } from 'react-use';

import {
  type Suggestion,
  placeIdToAddress,
} from '@service-initiation/shared-data-access-google';
import { ErrorType } from '@service-initiation/tech-care-data-access-tech-care-services';

import { type ZipCodeState } from '../tabs/store-selection-tab/zip-code/types';
import { validateZipcode } from '../tabs/store-selection-tab/zip-code/validateZipCode';

export type LocationSelect = {
  geolocationPositionError: number;
};
const NO_RESULTS = 'INVALID';
export type UseLocationSelectProps = {
  place: Suggestion;
  setGeolocationPositionError: (value: number) => void;
  setInputText: (text: string) => void;
  setValidationError: (error: ErrorType | undefined) => void;
  updateAddressComponents: (addressComponents: ZipCodeState) => void;
};
export const useLocationSelect = () => {
  return useAsyncFn(
    async ({
      place,
      setGeolocationPositionError,
      setInputText,
      setValidationError,
      updateAddressComponents,
    }: UseLocationSelectProps) => {
      let postalCode = undefined;
      let fullAddress = undefined;
      setGeolocationPositionError(0);
      if (place.id !== NO_RESULTS) {
        setInputText(place.value);
        postalCode = (await placeIdToAddress(place.id)).zip;
      }
      const location = place.value;
      const header = place.header;
      const subHeader = place.subHeader;
      const { error, isValid } =
        place.id !== NO_RESULTS
          ? await validateZipcode({
              fullAddress: { address: location },
            })
          : { error: undefined, isValid: false };

      if (isValid === true && error !== ErrorType.Error) {
        fullAddress = {
          address: location,
          header: header,
          subHeader: subHeader,
        };
        updateAddressComponents({
          fullAddress,
          geoLocation: undefined,
          postalCode,
        });
      } else {
        setValidationError(error);
      }
    },
    []
  );
};
